/* Package JSON Import will be here */
import React from "react";
import { Link } from "react-router-dom";
import { push } from "connected-react-router";
/* Package JSON Import will be here */

export const appRoutesConst = {
  index: "/",
  home: "/ivy/home",
  profile: "/ivy/profile",
  settings: "/ivy/settings",
  changeMobileNumber: "/ivy/changeMobileNumber",
  resetPassword: "/ivy/resetPassword",
  products: "/ivy/products",
  orderSummary: "/ivy/viewCart",
  productDetail: "/ivy/product",
  orderHistory: "/ivy/orders",
  orderHistoryDetails: "/ivy/orders",
  manageWholesalers: "/ivy/manageDistributors",
  checkout: "/ivy/checkout",
  favProducts: "/ivy/favProducts",
  promotions: "/ivy/promotions",
  promotionDetails: "/ivy/promotion",
  notification: "/ivy/notification",
  viewAllProducts: "/ivy/viewAllProducts",
  productList: "/ivy/productList",
  kpiDashboard: "/ivy/kpiDashboard",
  salesReturn: "/ivy/salesReturn",
  salesReturnProducts: "/ivy/salesReturnProducts",
  salesReturnSummary: "/ivy/salesReturnSummary",
  exchangeReturn: "/ivy/exchangeReturn",
  exchangeReturnResult: "/ivy/exchangeReturnResult",
  smartList: "/ivy/smartList",
  appGuidance: "/ivy/appGuidance",
  storeDashboard: "/ivy/storeDashboard",
  consumer: "/ivy/consumer",
  storeProducts: "/ivy/storeProducts",
  storeDisplay: "/ivy/storeDisplay",
  myPayment: "/ivy/myPayment",
  paymentDetails: "/ivy/paymentDetails",
  paymentResponse: "/ivy/paymentResponse",
  digitalContent: "/ivy/digitalContent",
  myComplaints: "/ivy/myComplaints",
  orderStatusDelivery: "/ivy/orderStatusDelivery",
  salesReturnHistory: "/ivy/salesReturnHistory",
  salesReturnHistoryDetails: "/ivy/salesReturnHistoryDetails",
  retailerLedger: "/ivy/retailerLedger",
  qpsSchemes: "/ivy/qpsSchemes",
  cancelOrder: "/ivy/cancelOrder",
  supportHelpline: "/ivy/supportHelpline",
  myRewards: "/ivy/myRewards",
  rewardHistory: "/ivy/rewardHistory",
  rewardsHistoryDetails: "/ivy/rewardHistoryDetails",
  myEarningsLedger: "/ivy/myEarningsLedger",
  clubEnrollment: "/ivy/clubEnrollment",
  survey: "/ivy/survey",
  rplProgram: "/ivy/rplProgram",
};

export const navigateToIndex = () => {
  return dispatch => {
    dispatch(push(appRoutesConst.index));
  };
};

export const navigateToCart = () => {
  return dispatch => {
    dispatch(push(appRoutesConst.orderSummary));
  };
};

export const navigateToProductDetail = (productIdPattern) => {
  return dispatch => {
    dispatch(push(appRoutesConst.productDetail + "/" + productIdPattern));
  };
};

export const navigateToHome = () => {
  return dispatch => {
    dispatch(push(appRoutesConst.home));
  };
};

export const navigateToProductList = (focusedTab = "") => {
  return dispatch => {
    dispatch(push(appRoutesConst.productList, focusedTab));
  };
};

export const navigateToRplProgram = () => {
  return dispatch => {
    dispatch(push(appRoutesConst.rplProgram));
  };
};

export const navigateToMyPayment = () => {
  return dispatch => {
    dispatch(push(appRoutesConst.myPayment));
  };
};

export const navigateToSettings = () => {
  return dispatch => {
    dispatch(push(appRoutesConst.settings));
  };
};

export const navigateToChangeMobileNumber = () => {
  return dispatch => {
    dispatch(push(appRoutesConst.changeMobileNumber));
  };
};

export const navigateToResetPassword = () => {
  return dispatch => {
    dispatch(push(appRoutesConst.resetPassword));
  };
};

export const navigateToOrderHistoryList = () => {
  return dispatch => {
    dispatch(push(appRoutesConst.orderHistory));
  };
};

export const navigateToCheckout = () => {
  return dispatch => {
    dispatch(push(appRoutesConst.checkout));
  };
};

export const navigateToRewardHistory = () => {
  return dispatch => {
    dispatch(push(appRoutesConst.rewardHistory));
  };
};

export const HomeLink = props => {
  return (
    <Link {...props} to={appRoutesConst.home}>
      {props.children}
    </Link>
  );
};

export const OrderHistoryLink = props => {
  return (
    <Link {...props} to={appRoutesConst.orderHistory}>
      {props.children}
    </Link>
  );
};

export const IndexLink = props => {
  return (
    <Link {...props} to={appRoutesConst.index}>
      {props.children}
    </Link>
  );
};

export const ManageWholesalerLink = props => {
  return (
    <Link {...props} to={`${appRoutesConst.manageWholesalers}`}>
      {props.children}
    </Link>
  );
};

export const OrderHistoryDetailLink = props => {
  if (!props.isFromDetails) {
    return (
      <Link to={appRoutesConst.orderHistoryDetails + "/" + props.orderId}>
        {props.children}
      </Link>
    );
  }
  else {
    return (props.children);
  }
};
export const RewardsHistoryDetailLink = props => {
  if (!props.isFromHistoryDetails) {
    return (
      <Link to={appRoutesConst.rewardsHistoryDetails + "/" + props.redemptionId}>
        {props.children}
      </Link>
    );
  }
  else {
    return (props.children);
  }
};

export const PaymentHistoryDetailLink = props => {
  return (
    <Link to={appRoutesConst.paymentDetails + "/" + props.invoiceId}>
      {props.children}
    </Link>
  );
};

export const navigateToSmartList = () => {
  return dispatch => {
    dispatch(push(appRoutesConst.smartList));
  };
};

export const navigateToAppGuidance = () => {
  return dispatch => {
    dispatch(push(appRoutesConst.appGuidance));
  };
};

export const navigateToConsumer = () => {
  return dispatch => {
    dispatch(push(appRoutesConst.consumer));
  };
};

export const navigateToStoreProducts = () => {
  return dispatch => {
    dispatch(push(appRoutesConst.storeProducts));
  };
};

export const navigateToStoreDisplay = () => {
  return dispatch => {
    dispatch(push(appRoutesConst.storeDisplay));
  };
};

export const navigateToSalesReturn = () => {
  return dispatch => {
    dispatch(push(appRoutesConst.salesReturn));
  };
};

export const navigateToSalesReturnHistory = () => {
  return dispatch => {
    dispatch(push(appRoutesConst.salesReturnHistory));
  };
};

export const navigateToMyRewards = () => {
  return dispatch => {
    dispatch(push(appRoutesConst.myRewards));
  };
};

export const navigateToRedemptionHistory = () => {
  return dispatch => {
    dispatch(push(appRoutesConst.rewardHistory));
  };
};

export const navigateToManageDistributors = () => {
  return dispatch => {
    dispatch(push(`${appRoutesConst.manageWholesalers}/myRewards`));
  };
};

export const SalesReturnHistoryDetailLink = props => {
  if (!props.isFromDetail) {
    return (
      <Link to={`${appRoutesConst.salesReturnHistoryDetails}/${props.returnId}`}>
        {props.children}
      </Link>
    );
  }
  else {
    return (props.children);
  }
};

export const navigateToRetailerSurvey = () => {
  return dispatch => {
    dispatch(push(appRoutesConst.survey));
  };
};